// Reserved keywords not allowed to use in the parser
export var keywords = {
  end: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/expression/keywords.js
// module id = null
// module chunks = 